import httpClient from './httpClient';

const MIGO_API_URL = 'https://api.migo.pe/api/v1';

// Token para la API de MIGO (se configurará desde el componente)
let MIGO_TOKEN = '';

export const migoService = {
  // Configurar el token de MIGO
  setToken: (token) => {
    MIGO_TOKEN = token;
  },

  // Consultar información de persona por DNI
  consultarDNI: async (dni) => {
    try {
      console.log('🔍 Consultando DNI:', dni);
      
      if (!MIGO_TOKEN) {
        throw new Error('Token de MIGO no configurado');
      }

      if (!dni || dni.length !== 8) {
        throw new Error('DNI debe tener 8 dígitos');
      }

      const response = await fetch(`${MIGO_API_URL}/dni`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          token: MIGO_TOKEN,
          dni: dni
        })
      });

      const data = await response.json();

      if (!response.ok) {
        console.error('❌ Error en consulta MIGO:', data);
        
        if (response.status === 403) {
          throw new Error('Token de acceso inválido o expirado');
        } else if (response.status === 404) {
          throw new Error('DNI no encontrado en la base de datos');
        } else {
          throw new Error(data.message || 'Error al consultar DNI');
        }
      }

      if (data.success && data.nombre) {
        console.log('✅ Consulta exitosa:', data);
        return {
          success: true,
          data: {
            dni: data.dni,
            nombre: data.nombre,
            success: data.success
          }
        };
      } else {
        console.log('⚠️ Respuesta sin datos válidos:', data);
        throw new Error('No se encontraron datos para el DNI proporcionado');
      }

    } catch (error) {
      console.error('❌ Error en migoService.consultarDNI:', error);
      return {
        success: false,
        error: error.message || 'Error desconocido al consultar DNI'
      };
    }
  },

  // Verificar si el token está configurado
  isTokenConfigured: () => {
    return !!MIGO_TOKEN;
  }
};

export default migoService; 